import * as React from 'react'
import { ReactElement } from 'react'
import BaseCombobox, { BaseComboboxProps } from './BaseCombobox'
import { FixedPriceType } from '../../config/registrationConfig'
import useFixedPriceTypes from '../../hooks/useFixedPriceTypes'

export type FixedPriceTypeComboboxProps = Omit<
    BaseComboboxProps<FixedPriceType>,
    'getEntityLabel' | 'getEntityValue' | 'entities'
> &
    Partial<Pick<BaseComboboxProps<FixedPriceType>, 'getEntityLabel'>>

export default function FixedPriceTypeCombobox(props: FixedPriceTypeComboboxProps): ReactElement {
    const { fixedPriceTypes } = useFixedPriceTypes()

    return (
        <BaseCombobox<FixedPriceType>
            entities={fixedPriceTypes}
            alphabetical
            getEntityLabel={vat => vat.name}
            getEntityValue={vat => vat.id}
            placeholderKey={'base.fixedpricetypecombobox.placeholder'}
            {...props}
        />
    )
}
